/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { type ReactNode, useState } from "react"
import Container from "@ecom/ui/components/Container"
import clsx from "clsx"
import { AppLink } from "@ecom/ui/components/AppLink"
import { SocialLinks } from "./SocialLinks"

import * as styles from "./footer.module.scss"
import { HalvaIcon } from "./HalvaIcon"

const defLicenseText = (
  <>
    {new Date().getFullYear()} © ПАО «Совкомбанк». Генеральная лицензия Банка России №963. <br />
    Кострома, пр. Текстильщиков, 46
  </>
)

type Props = {
  withSocialLinks?: boolean
  withFixedButton?: boolean
  orderNum?: string
  variant?: "abTest"
  licenseText?: ReactNode
}

export const Footer = ({
  withSocialLinks = false,
  withFixedButton = true,
  orderNum,
  variant,
  licenseText = defLicenseText,
}: Props) => (
  <footer className={clsx(styles.footer, variant && styles[variant])}>
    <Container className={clsx(styles.container, withFixedButton && styles.fixedButton)}>
      <div className={styles.card} data-exclude={orderNum}>
        <HalvaIcon className={styles.icon} />
        <div className={styles.top}>
          <div className={styles.links}>
            <div className={styles.phone}>
              <AppLink href="tel:88001007772">8 800 100-777-2</AppLink>
              <p>Для физ.лиц</p>
            </div>

            <div className={styles.phone}>
              <AppLink href="tel:88001011040">8 800 101-10-40</AppLink>
              <p>Для партнеров Халвы</p>
            </div>
          </div>
          {withSocialLinks && <SocialLinks />}
        </div>

        <div className={styles.bottom}>
          <p className={styles.cookie}>
            ПАО «Совкомбанк» использует cookie (файлы с&nbsp;данными о&nbsp;прошлых посещениях
            сайта) для&nbsp;персонализации сервисов и&nbsp;удобства пользователей — ознакомьтесь
            с&nbsp;Политикой обработки файлов cookie.&nbsp;Вы можете запретить сохранение cookie
            в&nbsp;настройках своего браузера.
          </p>
          <br />
          {licenseText && <p>{defLicenseText}</p>}
        </div>
      </div>
    </Container>
  </footer>
)
